module.exports = __webpack_public_path__ + "img/bell.38507c47.svg";